import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Shift, ShiftFormEmployee } from 'src/app/models/shift.model';
import { ShiftService } from 'src/app/Services/shift.service';

@Component({
  selector: 'app-delete-shift-dialog',
  templateUrl: './delete-shift-dialog.component.html',
  styleUrls: ['./delete-shift-dialog.component.css'],
  standalone: false
})
export class DeleteShiftDialogComponent implements OnInit {
  shift: Shift;
  assignedEmployees: ShiftFormEmployee[] = [];
  isLoadingEmployees = true;
  isDeleting = false;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: { shift: Shift },
    private dialogRef: MatDialogRef<DeleteShiftDialogComponent>,
    private shiftService: ShiftService,
    private snackBar: MatSnackBar
  ) {
    this.shift = data.shift;
  }

  ngOnInit(): void {
    this.loadShiftEmployees();
  }

  loadShiftEmployees(): void {
    if (!this.shift || !this.shift.id) {
      this.isLoadingEmployees = false;
      return;
    }
    
    this.isLoadingEmployees = true;
    this.shiftService.getShiftEmployees(this.shift.id).subscribe({
      next: (employees) => {
        this.assignedEmployees = employees.filter(emp => emp.on_this_shift);
        this.isLoadingEmployees = false;
      },
      error: (err) => {
        console.error('Failed to load shift employees', err);
        this.isLoadingEmployees = false;
      }
    });
  }

  onCancel(): void {
    this.dialogRef.close(false);
  }

  onDelete(): void {
    if (!this.shift || !this.shift.id) return;

    this.isDeleting = true;
    this.shiftService.deleteShift(this.shift.id).subscribe({
      next: (res) => {
        this.isDeleting = false;
        if (res && res.success) {
          this.snackBar.open('Shift deleted successfully', 'Close', { duration: 3000, panelClass: 'success-snackbar' });
          this.dialogRef.close(true);
        } else {
          this.snackBar.open('Failed to delete shift', 'Close', { duration: 3000, panelClass: 'error-snackbar' });
        }
      },
      error: (err) => {
        this.isDeleting = false;
        console.error('Failed to delete shift', err);
        this.snackBar.open('Error deleting shift', 'Close', { duration: 3000, panelClass: 'error-snackbar' });
      }
    });
  }
}
